import Main from '@/components/fenaju/components/include/Page.vue'

export default [
    {
        path: '/', component: Main, children: [
            {path: '', component: () => import('@/components/fenaju/components/Dashboard.vue'), name: 'dashboard.main'}
        ]
    }
]
